import { render, staticRenderFns } from "./psuFwfconForm.vue?vue&type=template&id=1d65fa7a&scoped=true"
import script from "./psuFwfconForm.vue?vue&type=script&lang=js"
export * from "./psuFwfconForm.vue?vue&type=script&lang=js"
import style0 from "./psuFwfconForm.vue?vue&type=style&index=0&id=1d65fa7a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d65fa7a",
  null
  
)

export default component.exports